import React, { useEffect, useState } from 'react';
import { purgeUnusedCSS, optimizeYouTubeEmbeds, extractCriticalCSS, measureCSSPerformance } from '../../utils/cssPurger';
import './CSSOptimizer.scss';

const CSSOptimizer = () => {
  const [optimizationStatus, setOptimizationStatus] = useState('idle');
  const [performanceMetrics, setPerformanceMetrics] = useState({});

  useEffect(() => {
    // Run CSS optimization after component mounts
    runOptimization();
  }, []);

  const runOptimization = async () => {
    try {
      setOptimizationStatus('running');
      
      // Measure initial performance
      const initialPerformance = measureCSSPerformance();
      
      // Optimize YouTube embeds
      const optimizedEmbeds = optimizeYouTubeEmbeds();
      
      // Extract critical CSS
      const criticalCSS = extractCriticalCSS();
      
      // Analyze unused CSS
      const purgeResults = purgeUnusedCSS();
      
      // Measure final performance
      setTimeout(() => {
        const finalPerformance = measureCSSPerformance();
        const improvement = initialPerformance - finalPerformance;
        
        setPerformanceMetrics({
          initialPerformance: initialPerformance.toFixed(2),
          finalPerformance: finalPerformance.toFixed(2),
          improvement: improvement.toFixed(2),
          optimizedEmbeds,
          criticalCSSCount: criticalCSS.length,
          unusedSelectors: purgeResults.unusedSelectors.length,
          estimatedSavings: purgeResults.estimatedSavings
        });
        
        setOptimizationStatus('completed');
      }, 1000);
      
    } catch (error) {
      console.error('CSS optimization failed:', error);
      setOptimizationStatus('error');
    }
  };

  if (optimizationStatus === 'idle') {
    return null; // Don't render anything until optimization starts
  }

  return (
    <div className="css-optimizer" style={{ display: 'none' }}>
      {/* Hidden component for performance optimization */}
      {optimizationStatus === 'running' && (
        <div className="optimization-status">
          <span>🔄 Optimizing CSS performance...</span>
        </div>
      )}
      
      {optimizationStatus === 'completed' && (
        <div className="optimization-results">
          <span>✅ CSS optimization complete</span>
          <span>📈 Performance improved by {performanceMetrics.improvement}ms</span>
          <span>🧹 Removed {performanceMetrics.unusedSelectors} unused selectors</span>
          <span>💾 Estimated savings: {performanceMetrics.estimatedSavings} KiB</span>
        </div>
      )}
      
      {optimizationStatus === 'error' && (
        <div className="optimization-error">
          <span>❌ CSS optimization failed</span>
        </div>
      )}
    </div>
  );
};

export default CSSOptimizer;
